<template>
    <div class="container py-4">
      <header class=" mb-4">
        <h1 class="mb-4 border-bottom pb-2">Content editor</h1>  <br>
 <h6>In this section, you can define and manage the content displayed to users. The content entered in the forms below will be shown within the app.
All changes made in the forms below will be saved after clicking Save Changes.</h6>


      
      </header>
  
      <section v-if="jsonData">
        <!-- Operator Image -->
<div class="mb-4">
  <h2 class="d-flex justify-content-between align-items-center">Operator Image</h2>
  <h6 class="d-flex justify-content-between align-items-center">The operator image is the logo displayed on the Home screen of the application. The recommended format is 240x130px. This logo is also shown on the playlist selection screen if the user has more than one playlist.

For the best visual result, make sure the logo itself has padding inside the image — it should not extend to the very edges of the file.</h6>
 
  <div class="card p-3">

    <label class="form-label">Image URL</label>
    <input v-model="jsonData.operator_image" class="form-control" placeholder="https://example.com/logo.png" />
    <div class="mt-2">
      <img :src="jsonData.operator_image" class="img-thumbnail" alt="Preview" />
    </div>
  </div>
</div>

        <!-- News -->
        <div class="mb-4">
          <h2 @click="toggleCollapse('banner_news')" class="d-flex justify-content-between align-items-center">
            Promo
            <span class="collapse-icon">{{ collapsed.banner_news ? '▼' : '▲' }}</span>
          </h2>
          <h6 class="d-flex justify-content-between align-items-center">This section displays announcements and promotional content to the user on the Home screen under the Promo section.
You can add an unlimited number of entries, but keep in mind that having too many items may slow down the application and negatively impact the user experience.
<br>
    Title: Headline of the promo

    Image URL: Link to the image (host it on a fast server to avoid slow loading) <br>

    Description: Content body — can be plain text or HTML. CSS is also supported, so you can combine text and images to create rich promotional material. <br>

Clicking Show Preview lets you see how the promo will appear to users. <br>

⚠️ At least one promo entry must be present. It is not allowed to leave this section empty.</h6>
 
          <div v-show="collapsed.banner_news">

            <div v-for="(item, index) in jsonData.banner_news" :key="item.id" class="card p-3 mb-3">
             
                <div class="row g-2 align-items-center">
                <div class="col-md-4">
                  <label :for="'title-' + index" class="form-label">Title</label>
                  <input :id="'title-' + index" v-model="item.title" class="form-control" placeholder="Title" />
                </div>
                <div class="col-md-5">
                  <label :for="'image-' + index" class="form-label">Image URL</label>
                  <input :id="'image-' + index" v-model="item.image" class="form-control" placeholder="Image URL" />
                </div>
                <div class="col-md-2">
                  <img :src="item.image" class="img-thumbnail" alt="Preview" />
                </div>
                <div class="col-md-1">
                  <button @click="removeItem('banner_news', index)" class="btn btn-danger">🗑</button>
                </div>
                <div class="col-12">
                  <label :for="'desc-' + index" class="form-label">Description</label>
                  <div class="col-md-12 mb-2">
  <label>HTML Source</label>
  <textarea v-model="item.description" class="form-control" rows="6" />
</div>

<div class="col-md-12">
  <button class="btn btn-secondary mb-2" @click="item.showPreview = !item.showPreview">
    {{ item.showPreview ? 'Hide Preview' : 'Show Preview' }}
  </button>

  <div v-if="item.showPreview" ><iframe
  class="preview-box"
  :srcdoc="getStyledPreview(item.description)"
  sandbox="allow-same-origin"
></iframe>
</div>
</div>

                </div>
              </div>
            </div>
            <button @click="addItem('banner_news')" class="btn btn-primary">Add Promo</button>
          </div>
        </div>
  
        <!-- Recommended -->
        <div class="mb-4">
          <h2  @click="toggleCollapse('recommended_order')"  class="d-flex justify-content-between align-items-center">Recommended Video on demand <span class="collapse-icon">{{ collapsed.recommended_order ? '▼' : '▲' }}</span>
          </h2>
          <h6 class="d-flex justify-content-between align-items-center">Recommended Video on Demand

This section lists video IDs from the server to be highlighted to the user under "Recommended Movies".
Enter the IDs as a comma-separated list. These entries will appear on the Home screen.

If no IDs are provided, the section will appear empty to the user.</h6>
 
          <div v-for="(item, index) in jsonData.recommended_order" :key="item.id" class="card p-3 mb-3">
            <div class="row g-2 align-items-center">
       
              <div class="col-md-12">
                <label :for="'rec-ids-' + index" class="form-label">ID List</label>
                <input :id="'rec-ids-' + index" v-model="item.idString" class="form-control" placeholder="ID List (comma-separated)" />
              </div>
              
            </div>
          </div>
         
        </div>
  
        <!-- Studios -->
        <div class="mb-4">
          <h2 @click="toggleCollapse('studios')" class="d-flex justify-content-between align-items-center">
            Studios
            <span class="collapse-icon">{{ collapsed.studios ? '▼' : '▲' }}</span>
          </h2>
          <h6 class="d-flex justify-content-between align-items-center">This section allows you to group movies and series by studio.
You can create multiple studios and assign them video IDs from your server. A single ID may appear in multiple studios or categories. <br>

Each studio has:<br>

    Studio Title – the name of the group  <br>

    Studio Image – an image representing the studio<br>

Images should be square and exactly 170x170px for best display.</h6>
          <div v-show="collapsed.studios">
            <div v-for="(item, index) in jsonData.studios" :key="item.id" class="card p-3 mb-3">
  <div class="row g-2 align-items-center">
    <div class="col-md-4">
      <label class="form-label">Studio Title</label>
      <input v-model="item.nazivKategorije" class="form-control" placeholder="Title" />
    </div>

    <div class="col-md-5">
      <label class="form-label">Studio Image</label>
      <input v-model="item.image" class="form-control" placeholder="Image URL" />
    </div>

    <div class="col-md-2">
      <img :src="item.image" class="img-thumbnail" alt="Preview" />
    </div>

    <div class="col-md-1">
      <button @click="removeItem('studios', index)" class="btn btn-danger">🗑</button>
    </div>

    <div class="col-12 mt-2">
      <label class="form-label">ID List</label>
      <input v-model="item.idString" class="form-control" placeholder="ID List (comma-separated)" />
    </div>
  </div>
</div>

            <button @click="addItem('studios')" class="btn btn-primary">Add Studio</button>
          </div>
        </div>
  
 

      </section>
      <div class="fixed-footer shadow-lg">
  <div class="save-status">
    <transition name="fade">
      <div v-if="saveMessage" :class="['alert', saveSuccess ? 'alert-success' : 'alert-danger']" class="mb-0 py-1 px-3">
        {{ saveMessage }}
      </div>
    </transition>
  </div>

  <button @click="saveOperatorJson" class="btn btn-success ms-3">
    <i class="bi bi-save2-fill me-1"></i> Save Changes
  </button>
</div>


    </div>
  </template>
  
  <script>
  import axios from "axios";
  
  export default {
    data() {
      return {
        abortController: null,
        saveMessage: null,
saveSuccess: true,
        jsonData: { banner_news: [], recommended_order: [], studios: [] },
        operator_image: "", // 👈 dodato
        ident: null,
        collapsed: {
      banner_news: true,
      recommended_order: true,
      studios: true,
      operatorImage: '',

    }
      };
    },
    created() {
    
    },
    beforeRouteLeave(to, from, next) {
  if (this.abortController) {
    console.log("⛔ Route leave - axios abort");
    this.abortController.abort();
  }
  next();
}
,
    mounted(){
        const userData = JSON.parse(localStorage.getItem("userData"));
      if (userData && userData.ident) {
        this.ident = userData.ident;
   
        this.loadOperatorJSON();
      }
    },
    beforeUnmount() {
  if (this.abortController) {
    this.abortController.abort();
  }
}
,
    methods: {
        getStyledPreview(description) {
    const defaultStyle = `
      <style>
        body {
          color: white;
          background: transparent;
          font-family: Arial, sans-serif;
        }
        a { color: #4da3ff; }
      </style>
    `;
    return defaultStyle + description;
  },
        async saveOperatorJson() {
  if (!this.ident || !this.jsonData) return alert("Missing ident or data");

  ['recommended_order', 'studios'].forEach(section => {
    this.jsonData[section].forEach(item => {
      item.idIzXC = item.idString
        .split(',')
        .map(id => parseInt(id.trim(), 10))
        .filter(id => !isNaN(id));
    });
  });

  try {
    const token = localStorage.getItem("adminToken");
    if (!token) return alert("Nedostaje auth token");

    await axios.post(
      "https://app.streamboxtv.live/api3002/api/save-operator-json",
      {
        ident: this.ident,
        jsonData: this.jsonData
      },
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    this.saveMessage = "Your changes have been saved.";
this.saveSuccess = true;

setTimeout(() => {
  this.saveMessage = null;
}, 4000);

  } catch (error) {
    console.error("Greška pri snimanju JSON-a:", error);
    this.saveMessage = "Greška pri snimanju JSON-a";
this.saveSuccess = true;

setTimeout(() => {
  this.saveMessage = null;
}, 4000);

  }
}


,
        toggleCollapse(section) {
    this.collapsed[section] = !this.collapsed[section];
  },
      logout() {
        localStorage.removeItem("adminToken");
        this.$router.push("/admin/login");
      },
      async loadOperatorJSON() {
  try {
    const token = localStorage.getItem("adminToken");

    const response = await axios.get(
      `https://app.streamboxtv.live/api3002/api/operator-json/${this.ident}`,
      {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    this.jsonData = response.data;

    ['recommended_order', 'studios'].forEach(section => {
      this.jsonData[section].forEach(item => {
        item.idString = item.idIzXC?.join(', ') || '';
      });
    });

  } catch (error) {
    console.error("❌ Error loading operator JSON:", error);
    alert("Failed to load operator JSON");
  }
}


,
 
      addItem(section) {
        const newId = this.jsonData[section].length + 1;
        let newItem = {};
        if (section === "banner_news") {
  newItem = {
    id: newId,
    title: "New News",
    description: "Description",
    image: "",
    showPreview: false, // 👈 ovo dodaje toggle preview stanje
  };
}

else if (section === "recommended_order") {
  newItem = { id: newId, title: "New Category", idIzXC: [], idString: "" };
} else if (section === "studios") {
  newItem = { id: newId, nazivKategorije: "New Studio", image: "", idIzXC: [], idString: "" };
}

        this.jsonData[section].push(newItem);
      },
      removeItem(section, index) {
        this.jsonData[section].splice(index, 1);
        this.jsonData[section].forEach((item, idx) => (item.id = idx + 1));
      },
      updateArray(item, field) {
        item[field] = item[field].split(",").map(id => parseInt(id.trim(), 10)).filter(id => !isNaN(id));
      },
      downloadJSON() {
        const blob = new Blob([JSON.stringify(this.jsonData, null, 2)], { type: "application/json" });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = "data.json";
        link.click();
      }
    }
  };
  </script>
  <style scoped>
.container {
  width: 100%;
  overflow-y: auto;
  background-color: #1e1e1e;

  margin-bottom: 200px;
  color: #fff;

  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}


/* Header */
 h2 {
  color: #00bfff;
}
h6{
    color:silver;
}
h2{
    margin-top:50px;
    font-size: 1.5em;
}
/* Cards */
.card {
  border: 1px solid #444;
  border-radius: 8px;
  background-color: #2b2b2b;
  color: #fff;
}

/* Form */
label.form-label {
  color: #ccc;
}

input.form-control,
textarea.form-control {
  background-color: #1c1c1c;
  color: #fff;
  border: 1px solid #444;
  box-shadow: none;
}

input.form-control::placeholder,
textarea.form-control::placeholder {
  color: #777;
}

input.form-control:focus,
textarea.form-control:focus {
  border-color: #00bfff;
  outline: none;
  background-color: #252525;
  color: #fff;
}

/* Buttons */
.btn {
  font-weight: 500;
}

.btn-success {
 
  background-color: #28a745;
  border-color: #28a745;
}

.btn-danger {
  background-color: #dc3545;
  border-color: #dc3545;
}

.btn-primary {
  background-color: #007bff;
  border-color: #007bff;
}

.btn-info {
  background-color: #17a2b8;
  border-color: #17a2b8;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  color: white;
}

.btn:hover {
  opacity: 0.9;
}

/* Thumbnail images */
img.img-thumbnail {
  max-height: 60px;
  object-fit: contain;
  background-color: #121212;
  border: 1px solid #333;
}

/* JSON Preview */
pre {
  font-size: 13px;
  white-space: pre-wrap;
  word-break: break-word;
  background-color: #1e1e1e;
  color: #00ff99;
  border: 1px solid #444;
}

/* Collapse arrow color */
.toggle-indicator,
h2 span {
  color: #bbb;
}

/* Margin for sections */
.mb-4 {
  margin-top: 20px;
}
.preview-box {
  min-height: 550px;
  width:100%;
  border: 1px solid #444;
  padding: 10px;
  background-color: #1e1e1e;
  color: white;
  border-radius: 6px;
}
/* Tooltip '?' */
.info-tooltip {
  display: inline-block;
  margin-left: 8px;
  width: 20px;
  height: 20px;
  background-color: #007bff;
  color: #fff;
  border-radius: 50%;
  text-align: center;
  font-weight: bold;
  font-size: 14px;
  cursor: help;
  line-height: 20px;
}

/* Collapse strelice */
.collapse-icon {
  font-size: 22px;
  color: #00bfff;
  transition: transform 0.2s;
}
.collapse-icon:hover {
  transform: scale(1.2);
}

/* Fixed Save/Footer */
.fixed-footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0; /* možeš i izostaviti */
  width: 50%;

  padding: 25px 30px;
  background-color: rgb(25, 31, 37);
  border-top: 1px solid #333;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - var(--scrollbar-width, 16px)); /* oduzmi širinu skrolbara */

}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
.collapse-icon{
    cursor: pointer;
}
.title-component{
    color:white;
}
  </style>
  